import { MenuNav } from "@common/index";

export const AdminSubHeader = () => {
    const links = [
        { to: "/a/inventory/products", label: "Products" },
        { to: "/a/inventory/categories", label: "Categories" },
        { to: "/a/inventory/Import", label: "Import" },
    ];

    return <MenuNav links={links} />;
};